import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../store/useAuthStore'
import { useI18n } from '../i18n'
import { AuthArea } from '../components/AuthArea'

export function HomePage() {
  const { t } = useI18n()
  const navigate = useNavigate()
  const user = useAuthStore((s) => s.user)

  return (
    <div className="flex min-h-full flex-col">
      {/* Header */}
      <header className="flex items-center justify-between px-6 py-4">
        <h1 className="text-lg font-bold text-text">{t('songbook.title')}</h1>
        <AuthArea />
      </header>

      {/* Main Content Area */}
      <main className="flex flex-1 items-center justify-center px-4">
        <div className="text-center">
          <h2 className="mb-3 text-3xl font-bold">
            {user ? t('home.welcome') + ', ' + user.username : t('home.welcomeGuest')}
          </h2>
          <p className="mb-6 text-text-muted">{t('home.description')}</p>
          <button
            className="rounded-lg bg-primary px-6 py-3 font-semibold text-white active:bg-primary-dark"
            onClick={() => navigate('/songs')}
          >
            {t('songbook.title')}
          </button>
        </div>
      </main>
    </div>
  )
}
